// extracted by mini-css-extract-plugin
module.exports = {"header":"WorkspacesBox_header__15Fy8","box":"WorkspacesBox_box__1ydzu","node":"WorkspacesBox_node__1JGQ5"};